import axios from 'axios'

const url = process.env.REACT_APP_URL

export const login = async (email: string, password: string) => {
  try {
    const res = await axios.get(process.env.REACT_APP_URL + "/user/auth", { params: { email: email, password: password } })
    return res.data
  } catch (err) {
    console.log(err)
  }
}

export const SAML = async (atlas: string, password: string) => {
  try {
    console.log("TRY SAML")
    const res = await axios.post(process.env.REACT_APP_URL + "/login", { params: { atlas: atlas, password: password } })
    console.log("SAML", res)
    return res
  } catch (err) {
    console.log(err)
  }
}

export const logout = async (token) => {
  try {
    const ssoURL = url?.replace("/backend", "")
    const SSOSignout = await axios.post(ssoURL + "/logout")
    console.log(SSOSignout)
    const res = await axios.get(url + '/user/logout', { params: { token: token } })
    return res.data
  } catch (err) {
  }
}

export const refreshToken = async () => {
  const token = {
    refreshToken: localStorage.getItem('refreshToken'),
    accessToken: localStorage.getItem('accessToken')
  }

  try {
    const res = await axios.post(url + '/user/token', {
      token: JSON.stringify(token)
    })
    console.log(res)
    return res
  } catch (err) {
    return err()
  }
}